import { ZodObject, ZodEffects, ZodArray } from "zod";
import type { ZodTypeAny } from "zod";
import { getShape } from "./step-schema.helper";
import type { UseFormReturn } from "react-hook-form";

export function getStepFields(
  stepId: string,
  schema: ZodTypeAny,
  form: UseFormReturn<any>
): string[] {
  const shape = getShape(schema);

  const stepFields: string[] = [];

  for (const [key, value] of Object.entries(shape)) {
    const path = `${stepId}.${key}`;

    if (value instanceof ZodObject || value instanceof ZodEffects) {
      const nestedShape = getShape(value);
      for (const nestedKey of Object.keys(nestedShape)) {
        stepFields.push(`${path}.${nestedKey}`);
      }
    } else if (value instanceof ZodArray) {
      // 👉 siempre validar el array raíz
      stepFields.push(path);

      // obtener valores actuales del array
      const items = form.getValues(path) as any[];

      if (Array.isArray(items)) {
        const element = value._def.type;
        if (element instanceof ZodObject) {
          const nestedShape = element.shape;
          for (let i = 0; i < items.length; i++) {
            for (const nestedKey of Object.keys(nestedShape)) {
              stepFields.push(`${path}.${i}.${nestedKey}`);
            }
          }
        }
      }
    } else {
      stepFields.push(path);
    }
  }

  return stepFields;
}
